import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import { getHosts } from '../services/hostService';
import { getServers } from '../services/serverService';
import { getBackups } from '../services/backupService';

const DashboardPage = () => {
  const [stats, setStats] = useState({
    hosts: 0,
    servers: 0,
    backups: 0
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [hosts, servers, backups] = await Promise.all([
          getHosts(),
          getServers(),
          getBackups()
        ]);
        console.log('Fetched stats:', { hosts, servers, backups });
        setStats({
          hosts: hosts.length,
          servers: servers.length,
          backups: backups.length
        });
      } catch (error) {
        console.error('Error fetching stats:', error);
      }
    };

    fetchStats();
  }, []);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Dashboard
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant="h6">Hosts</Typography>
            <Typography variant="h3">{stats.hosts}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant="h6">Servers</Typography>
            <Typography variant="h3">{stats.servers}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant="h6">Backups</Typography>
            <Typography variant="h3">{stats.backups}</Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardPage;